import type { Rect } from "@yjsgames/phaser-ui/panel-content";

export const SPACESHIP_INFO_PANEL_W = 326;
export const SPACESHIP_INFO_PANEL_H = 500;

export interface SpaceshipInfoPopupLayout {
  readonly panel: Rect;
  readonly title: Rect;
  readonly image: Rect;
  readonly desc: Rect;
  readonly flavor: Rect;
  readonly projectiles: Rect;
  readonly unlock: Rect;
  readonly gridTitle: Rect;
  readonly grid: Rect;
  readonly equipButton: Rect;
}

export function computeSpaceshipInfoPopupLayout(
  cx: number,
  cy: number,
  gridWidth: number,
  gridHeight: number,
): SpaceshipInfoPopupLayout {
  const top = cy - SPACESHIP_INFO_PANEL_H / 2;
  return {
    panel: {
      x: cx - SPACESHIP_INFO_PANEL_W / 2,
      y: top,
      width: SPACESHIP_INFO_PANEL_W,
      height: SPACESHIP_INFO_PANEL_H,
    },
    title: {
      x: cx - 120,
      y: top + 14,
      width: 240,
      height: 30,
    },
    image: {
      x: cx - 53,
      y: top + 58,
      width: 106,
      height: 72,
    },
    desc: {
      x: cx - (SPACESHIP_INFO_PANEL_W - 42) / 2,
      y: top + 136,
      width: SPACESHIP_INFO_PANEL_W - 42,
      height: 48,
    },
    flavor: {
      x: cx - (SPACESHIP_INFO_PANEL_W - 52) / 2,
      y: top + 186,
      width: SPACESHIP_INFO_PANEL_W - 52,
      height: 22,
    },
    projectiles: {
      x: cx - (SPACESHIP_INFO_PANEL_W - 44) / 2,
      y: top + 212,
      width: SPACESHIP_INFO_PANEL_W - 44,
      height: 18,
    },
    unlock: {
      x: cx - (SPACESHIP_INFO_PANEL_W - 44) / 2,
      y: top + 236,
      width: SPACESHIP_INFO_PANEL_W - 44,
      height: 18,
    },
    gridTitle: {
      x: cx - 90,
      y: top + 266,
      width: 180,
      height: 18,
    },
    grid: {
      x: cx - gridWidth / 2,
      y: top + 294,
      width: gridWidth,
      height: gridHeight,
    },
    equipButton: {
      x: cx - 78,
      y: top + SPACESHIP_INFO_PANEL_H - 49,
      width: 156,
      height: 34,
    },
  };
}
